import { render, staticRenderFns } from "./PieRing.vue?vue&type=template&id=7d9fbdb9&scoped=true"
import script from "./PieRing.vue?vue&type=script&lang=js"
export * from "./PieRing.vue?vue&type=script&lang=js"
import style0 from "./PieRing.vue?vue&type=style&index=0&id=7d9fbdb9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d9fbdb9",
  null
  
)

export default component.exports